import Vue from "vue";
import { Modal, Button } from "ant-design-vue-findsoft";
Vue.use(Modal);
export default Vue.extend({
    components: {
        aButton: Button
    },
    data: function () {
        return {
            list: [],
            visible: false
        };
    },
    computed: {
        dataList: function () {
            var list = this.list.map(function (ele) {
                var data = ele;
                data.class = "gray";
                if (ele.firstEntry && ele.toState == "已结束") {
                    // 进去过且已结束的实验变为已完成
                    (data.toState = "已完成"), (data.class = "green");
                }
                else if (ele.toState == "进行中") {
                    data.class = "orange";
                }
                return data;
            });
            return list;
        }
    },
    methods: {
        gonovice: function (v) {
            if (v.toState == "进行中") {
                console.log(new Date(v.endTime).getTime() - new Date().getTime());
                if (new Date(v.endTime).getTime() - new Date().getTime() <
                    v.totalTime * 60000 && !v.firstEntry) {
                    return (this.visible = true);
                }
                sessionStorage.setItem("isExpOver", "false");
                sessionStorage.setItem("firstEntry", v.firstEntry);
                sessionStorage.setItem("caseData", JSON.stringify(v));
                sessionStorage.removeItem("endstate");
                this.$router.push({
                    name: "doCase",
                    params: {
                        id: v.intelligentExperimentId,
                        intelligentExpId: v.intelligentExpId
                    }
                });
            }
            else if (v.toState == "已完成") {
                // this.$store.commit("changeExpState", true);
                sessionStorage.setItem("isExpOver", "true");
                sessionStorage.setItem("firstEntry", v.firstEntry);
                sessionStorage.removeItem("endstate");
                sessionStorage.setItem("expState", "已结束");
                this.$router.push({
                    name: "doCase",
                    params: {
                        id: v.intelligentExperimentId,
                        intelligentExpId: v.intelligentExpId
                    }
                });
            }
        },
        query: function () {
            var _this = this;
            var data = {
                pageNo: 1,
                pageSize: 999
            };
            this.$axios.queryExperimentMemberList(data).then(function (res) {
                if (res.data.success) {
                    _this.list = res.data.data.list.map(function (res1) {
                        if (res1.expType) {
                            res1.expType = JSON.parse(res1.expType);
                        }
                        return res1;
                    });
                }
            });
        }
    },
    created: function () {
        this.query();
    }
});
